import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { BottomNavigation } from "@/components/layout/BottomNavigation";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useAuth, API } from "@/App";
import axios from "axios";
import {
  Library,
  ChevronLeft,
  ExternalLink,
  BookOpen,
  Wrench,
  Folder,
  Sparkles,
  ShoppingBag,
  Download,
  FileText,
  Brain,
  Heart,
  Shield,
  Users,
  Frown,
  AlertTriangle,
  Target,
  Zap,
  Smile,
  ChevronDown,
  ChevronUp,
  Bell,
  Plus,
  Loader2
} from "lucide-react";

const TRUENORTH_STORE_URL = "https://www.truenorth-zone.com/";

// Vault documents with real Google Drive links
const VAULT_DOCUMENTS = {
  free: {
    id: "free",
    title: "FREE DOWNLOADS",
    description: "Free resources to support your journey - no subscription required.",
    icon: Download,
    color: "from-green-500/20 to-green-600/10",
    accent: "#22C55E",
    documents: [
      {
        title: "The Power of a Growth Mindset",
        icon: Brain,
        url: "https://customer-assets.emergentagent.com/job_path-unfolds/artifacts/25lv4ltw_The%20Power%20of%20a%20Growth%20Mindset%20.pdf"
      },
      {
        title: "Turning Anxiety into Calm",
        icon: Heart,
        url: "https://customer-assets.emergentagent.com/job_path-unfolds/artifacts/p37n0rf7_Turning%20Anxiety%20into%20Calm.pdf"
      }
    ]
  },
  reflection: {
    id: "reflection",
    title: "REFLECTION",
    description: "Guided reflection resources, worksheets, and journaling prompts to deepen your self-awareness.",
    icon: BookOpen,
    color: "from-amber-500/20 to-amber-600/10",
    accent: "#D4A574",
    folderUrl: "https://drive.google.com/drive/folders/1nFc1Q9TuW3uubk7EnWl_DPBUy-NVUMQ4?usp=drive_link",
    documents: [
      {
        title: "Journal Prompts",
        icon: FileText,
        url: "https://drive.google.com/file/d/1pAMOs1Z0bNHZwC1mF1uEq4HiGgt5RBZm/view?usp=drive_link"
      },
      {
        title: "Calming Your Mind -- 70 Page Journal",
        icon: Brain,
        url: "https://drive.google.com/file/d/1yDEOOwej4c63YXlkI0Ccpzjt-QNumPRa/view?usp=drive_link"
      },
      {
        title: "Journalling Prompt Sheets",
        icon: FileText,
        url: "https://drive.google.com/file/d/1OP5wZGGQfPXDYxzTSzLeXGaaTr0-kEsb/view?usp=drive_link"
      },
      {
        title: "Self Care Journal -- 70 Pages",
        icon: Heart,
        url: "https://drive.google.com/file/d/1bgX3gpedVPhPNizIK9KO50AylpM3l8YE/view?usp=drive_link"
      },
      {
        title: "TrueNorth Vision Kit -- Complete Kit with Worksheets (200 pages)",
        icon: Target,
        url: "https://drive.google.com/file/d/1tpH1L2KMsQoG1id1cK65XiuBI0x2k80Z/view?usp=drive_link"
      },
      {
        title: "You Are the Difference Journal",
        icon: Sparkles,
        url: "https://drive.google.com/file/d/1wh5Av2gj3H98cv02GH1tqXXNrOwcnHwo/view?usp=drive_link"
      }
    ]
  },
  tools: {
    id: "tools",
    title: "ACTION",
    description: "Workbooks, worksheets and more - growing monthly.",
    icon: Wrench,
    color: "from-emerald-500/20 to-emerald-600/10",
    accent: "#5D9E9E",
    folderUrl: "https://drive.google.com/drive/folders/19nO7K6cTXjQU8EyP6VqiBDlAofIbNb2g?usp=drive_link",
    documents: [
      {
        title: "Anger Management Workbook",
        icon: AlertTriangle,
        url: "https://drive.google.com/file/d/1yVROFYZSeM-VxaiV_eGyKUlBEnmAnFpK/view?usp=drive_link"
      },
      {
        title: "Acceptance Worksheet",
        icon: Heart,
        url: "https://drive.google.com/file/d/1LwlUXIPmvvPLBwHSUXkvvILUrGyO4CBn/view?usp=drive_link"
      },
      {
        title: "Anxiety Workbook",
        icon: Zap,
        url: "https://drive.google.com/file/d/1vngoo6tpvKDs_u6vkCNHRAr4EpfDSCnn/view?usp=drive_link"
      },
      {
        title: "Depression Workbook",
        icon: Frown,
        url: "https://drive.google.com/file/d/1JCsMqw-azeECj7L0qOAHmOPYGUsx9L0h/view?usp=drive_link"
      },
      {
        title: "Cognitive Distortion Worksheet",
        icon: Brain,
        url: "https://drive.google.com/file/d/1LPapKa8j_eqvSJikzZUACGs4plbP11-g/view?usp=drive_link"
      },
      {
        title: "Emotional Safety Plan",
        icon: Shield,
        url: "https://drive.google.com/file/d/14tza3wuo9zEk2q8P5RGUwbg84_esN0dZ/view?usp=drive_link"
      },
      {
        title: "Flight, Fight, Freeze and Fawn Worksheet",
        icon: AlertTriangle,
        url: "https://drive.google.com/file/d/1gO_WqRG534Stlnea2rd7tILvXYkY6BUl/view?usp=drive_link"
      },
      {
        title: "Healthy Relationship Workbook",
        icon: Users,
        url: "https://drive.google.com/file/d/1HwEW3fCoBtUvZAoxmz_WzB0lGry3fTfx/view?usp=drive_link"
      },
      {
        title: "Master Your Inner Critic Worksheets",
        icon: Brain,
        url: "https://drive.google.com/file/d/1T9DsTyaAYBTPJQu3N9eMXxb7S-zSwPYP/view?usp=drive_link"
      },
      {
        title: "Self Esteem and Confidence Workbook",
        icon: Smile,
        url: "https://drive.google.com/file/d/1mUQ-0fo2QB3ZhSEicAN_MnXVULHVerMf/view?usp=drive_link"
      },
      {
        title: "Sitting With My Emotions Worksheet",
        icon: Heart,
        url: "https://drive.google.com/file/d/19qzEWtXYh7EZQuMGR27wuPxKagpl8nRf/view?usp=drive_link"
      },
      {
        title: "Window of Tolerance Worksheet",
        icon: Target,
        url: "https://drive.google.com/file/d/1iII_rv1hDQ1khXp05IIg3DGrqJBu99nU/view?usp=drive_link"
      }
    ]
  }
};

// Document Card Component
function DocumentCard({ doc, accent }) {
  const DocIcon = doc.icon || FileText;
  
  return (
    <div className="flex items-center gap-3 p-3 bg-white/5 rounded-xl hover:bg-white/10 transition-colors">
      <div 
        className="w-10 h-10 rounded-lg flex items-center justify-center shrink-0"
        style={{ backgroundColor: `${accent}20` }}
      >
        <DocIcon className="w-5 h-5" style={{ color: accent }} />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-bold truncate" style={{ color: '#a69373' }}>{doc.title}</p>
      </div>
      <a
        href={doc.url}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => e.stopPropagation()}
        className="px-3 py-1.5 rounded-lg bg-white/10 text-xs font-medium hover:bg-white/20 transition-colors flex items-center gap-1.5 shrink-0 !text-white"
        data-download-btn="true"
      >
        <Download className="w-3.5 h-3.5 !text-white" />
        <span className="!text-white">Download</span>
      </a>
    </div>
  );
}

// Vault Section Component
function VaultSection({ section }) {
  const [expanded, setExpanded] = useState(false);
  const SectionIcon = section.icon;
  
  return (
    <Card 
      className="glass-card overflow-hidden animate-fade-in"
      data-testid={`vault-section-${section.id}`}
    >
      <CardContent className="p-0">
        {/* Accent bar */}
        <div 
          className="h-1.5 w-full"
          style={{ backgroundColor: section.accent }}
        />
        
        {/* Header - clickable to expand/collapse */}
        <button
          className="w-full p-5 flex items-start gap-4 text-left hover:bg-white/5 transition-colors"
          onClick={() => setExpanded(!expanded)}
        >
          {/* Icon */}
          <div 
            className={`w-14 h-14 rounded-2xl flex items-center justify-center shrink-0 bg-gradient-to-br ${section.color}`}
          >
            <SectionIcon className="w-7 h-7" style={{ color: section.accent }} />
          </div>
          
          {/* Content */}
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2 mb-1">
              <h3 className="text-lg font-heading font-bold" style={{ color: '#a69373' }}>
                {section.title}
              </h3>
              <Folder className="w-4 h-4" style={{ color: 'rgba(166, 147, 115, 0.3)' }} />
            </div>
            <p className="text-sm leading-relaxed" style={{ color: 'rgba(166, 147, 115, 0.6)' }}>
              {section.description}
            </p>
            <p className="text-xs mt-2" style={{ color: 'rgba(166, 147, 115, 0.4)' }}>
              {section.documents.length} documents
            </p>
          </div>
          
          {/* Expand indicator */}
          <div className="shrink-0 mt-2">
            {expanded ? (
              <ChevronUp className="w-5 h-5 text-white/30" />
            ) : (
              <ChevronDown className="w-5 h-5 text-white/30" />
            )}
          </div>
        </button>
        
        {/* Expanded documents list */}
        {expanded && (
          <div className="px-5 pb-5 space-y-2 animate-fade-in border-t border-white/10 pt-4">
            {section.documents.map((doc) => (
              <DocumentCard key={doc.url || doc.title} doc={doc} accent={section.accent} />
            ))}
            
            {/* Open folder button - only show if section has a folderUrl */}
            {section.folderUrl && (
              <div className="pt-3">
                <Button 
                  className="btn-primary w-full"
                  onClick={() => window.open(section.folderUrl, '_blank', 'noopener,noreferrer')}
                >
                  <ExternalLink className="w-4 h-4 mr-2" />
                  Open All in Google Drive
                </Button>
              </div>
            )}
          </div>
        )}
      </CardContent>
    </Card>
  );
}

export default function VaultPage() {
  const navigate = useNavigate();
  const { token } = useAuth();
  const [adminResources, setAdminResources] = useState([]);
  const [loadingResources, setLoadingResources] = useState(true);
  
  // Fetch admin-uploaded resources
  const fetchResources = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/vault/resources`, {
        withCredentials: true
      });
      setAdminResources((res.data || []).filter(r => {
        // Filter out broken/unwanted resources
        const brokenTitles = [
          'Morning Alignment Protocol',
          'Weekly Review Framework', 
          'Thought Pattern Tracker',
          'Belief Audit Template',
          'Boundary Setting Guide',
          'Vision Board Template',
          'Fear Inventory Worksheet',
          'Daily Check-In Template'
        ];
        return !brokenTitles.includes(r.title);
      }));
    } catch (error) {
      // Vault resources are optional - graceful degradation
      if (process.env.NODE_ENV === 'development') {
        console.error('Failed to fetch vault resources:', error);
      }
    } finally {
      setLoadingResources(false);
    }
  }, []);
  
  useEffect(() => {
    fetchResources();
  }, [fetchResources]);

  return (
    <div className="min-h-screen bg-background pb-28" data-testid="vault-page">
      {/* Header */}
      <header 
        className="sticky top-0 z-40 backdrop-blur-lg border-b border-black/5"
        style={{
          backgroundImage: `linear-gradient(rgba(11,40,33,0.85), rgba(11,40,33,0.9)), url('https://customer-assets.emergentagent.com/job_path-unfolds/artifacts/va4i7lvj_ChatGPT%20Image%20Feb%2014%2C%202026%2C%2012_49_01%20PM.png')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="px-4 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Button 
              variant="ghost" 
              size="sm" 
              className="h-8 w-8 p-0"
              onClick={() => navigate("/dashboard")}
            >
              <ChevronLeft className="w-5 h-5 text-[#a69373]" />
            </Button>
            <div>
              <h1 className="text-lg font-heading text-[#a69373]">The Vault</h1>
              <p className="text-xs text-[#a69373]/60 font-semibold">Your resource library</p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <button className="w-9 h-9 rounded-full bg-black/30 backdrop-blur-sm flex items-center justify-center">
              <Bell className="w-4 h-4 text-[#a69373]" />
            </button>
            <a 
              href="https://www.truenorth-zone.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-black/30 backdrop-blur-sm text-[#a69373] text-sm font-semibold hover:bg-black/40 transition-colors"
              style={{ zIndex: 9999, position: 'relative', pointerEvents: 'all' }}
            >
              <ShoppingBag className="w-4 h-4" />
              Shop
            </a>
          </div>
        </div>
      </header>
      
      <main className="px-4 py-6 max-w-4xl mx-auto">
        {/* Hero Section */}
        <header className="mb-8 animate-fade-in">
          <Card className="glass-card rounded-2xl overflow-hidden">
            <CardContent className="p-6 sm:p-8 relative">
              {/* Background decoration */}
              <div className="absolute top-4 right-4 opacity-10">
                <Library className="w-24 h-24" />
              </div>
              
              <div className="relative">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-12 h-12 rounded-xl bg-primary/20 flex items-center justify-center">
                    <Library className="w-6 h-6 text-primary" />
                  </div>
                  <div>
                    <h2 className="text-xl font-heading text-foreground">Resource Library</h2>
                    <p className="text-foreground/50 text-sm">Access your transformation toolkit</p>
                  </div>
                </div>
                
                <p className="text-foreground/70 leading-relaxed">
                  These curated resources support your journey of self-discovery and growth. 
                  Each folder contains worksheets, guides, and tools designed to deepen your practice.
                </p>
              </div>
            </CardContent>
          </Card>
        </header>

        {/* Vault Sections */}
        <section className="space-y-4">
          <VaultSection section={VAULT_DOCUMENTS.free} />
          <VaultSection section={VAULT_DOCUMENTS.reflection} />
          <VaultSection section={VAULT_DOCUMENTS.tools} />
        </section>
        
        {/* Admin-Uploaded Resources */}
        {adminResources.length > 0 && (
          <section className="mt-6 space-y-4 animate-fade-in" style={{ animationDelay: "100ms" }}>
            <div className="flex items-center gap-2 px-1">
              <Plus className="w-4 h-4 text-[#a69373]" />
              <h3 className="text-sm font-heading text-[#a69373] uppercase tracking-wider">Additional Resources</h3>
            </div>
            <div className="space-y-3">
              {adminResources.map((resource) => (
                <Card 
                  key={resource.resource_id} 
                  className="glass-card overflow-hidden"
                  data-testid={`admin-resource-${resource.resource_id}`}
                >
                  <CardContent className="p-4">
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 rounded-xl bg-[#a69373]/20 flex items-center justify-center shrink-0">
                        <FileText className="w-5 h-5 text-[#a69373]" />
                      </div>
                      <div className="flex-1 min-w-0">
                        <h4 className="text-foreground font-medium text-sm">{resource.title}</h4>
                        {resource.description && (
                          <p className="text-foreground/60 text-xs mt-1 line-clamp-2">{resource.description}</p>
                        )}
                        {resource.url && (
                          <a 
                            href={resource.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center gap-1 text-[#a69373] text-xs mt-2 hover:underline"
                          >
                            <ExternalLink className="w-3 h-3" />
                            Open Resource
                          </a>
                        )}
                      </div>
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          </section>
        )}
        
        {/* Loading indicator for resources */}
        {loadingResources && (
          <div className="flex justify-center py-4">
            <Loader2 className="w-5 h-5 text-[#a69373] animate-spin" />
          </div>
        )}

        {/* Info Card */}
        <section className="mt-8 animate-fade-in" style={{ animationDelay: "200ms" }}>
          <Card className="glass-card bg-white/5">
            <CardContent className="p-5">
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 rounded-lg bg-primary/20 flex items-center justify-center shrink-0">
                  <Sparkles className="w-4 h-4 text-primary" />
                </div>
                <div>
                  <p className="text-foreground/60 text-sm leading-relaxed">
                    <span className="text-foreground/80 font-medium">Tip:</span> Save these folders to your 
                    Google Drive for easy access. New resources are added regularly as part of your 
                    transformation journey.
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        </section>
      </main>
      
      <BottomNavigation />
    </div>
  );
}
